export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-align-center-3b93e006fd5272a48f07235f0cf19064.svg";